import React from "react";
import { InputRangeRow } from "./index";
// Used by Heli KV2008B and Heli KV2019B machines

export default function DelayedStopLowerRow() {
   return (
      <InputRangeRow
         titleProp={"Delayed Start for Lower"}
         descriptionProp={"secs"}
         sizeProp={6}
         colSizeProp={6}
         typeProp={"text"}
         minProp={0.0}
         maxProp={15.0}
         propertyNameProp={"delayLower"}
         errorDialogueProp={"0.0-15.0 only"}
         floatProp={true}
      />
   );
}
